/**
 * GET /payment-assignment/task-summary
 * Response shape is role-dependent (MAKER/ESCALATOR vs CHECKER).
 */

export interface AssignedSummary {
  totalAssignment: number
  totalPending: number
  totalCompleted: number
}

export interface CheckerSummary {
  pendingAssignment: number
  escalatedAssignment: number
  totalAssignment: number
}

export type TaskSummary = AssignedSummary | CheckerSummary

export function isCheckerSummary(s: TaskSummary): s is CheckerSummary {
  return 'pendingAssignment' in s
}
